import * as Yup from "yup";
import { AddressSchema } from "store/schemas/AddressSchema";
import { QuantitySchema } from "./QuantitySchema";

export const LocationWithQuantitySchema = Yup.object().shape({
  location: AddressSchema.required().default(AddressSchema.cast()),
  quantity: QuantitySchema.required().default(QuantitySchema.cast()),
});
